import axios from 'axios';
import {backendHost} from '../../config';

export const postBrands = (params) => {
    return axios.post(`${backendHost}/api/partners/admin/brands`, params);
};